import * as React from "react";
import i18n from "../../../../i18n/i18n";
import {Popup} from "../../../../common/components/shared/popup/popup";
import {ReactComponent as EnableIcon} from "../../../../statics/icons/icon_enable.svg";
import "./enablePopup.scss";
import {HttpError} from "../../../../common/components/shared/httpError/httpError";
import {AxiosResponse} from "axios";
import {HttpErrorModel} from "../../../../common/models/httpError";
import {Api} from "../../../../helpers/api";

interface EnablePopupProps {
    displayPopup: boolean;
    confirm: () => void;
    closePopup: () => void;
    username: string;
    response: AxiosResponse<HttpErrorModel[] | any> | undefined;
    isWaiting: boolean;
}

export default function EnablePopup(props: EnablePopupProps): React.ReactElement {
    const content = <div>
        {i18n.t("administration.enableAction.firstPart")}
        <b>{props.username}</b>
        {i18n.t("administration.enableAction.lastPart")}
    </div>;

    return (
        <Popup
            open={props.displayPopup}
            className="enable-popup"
            header={i18n.t("administration.enableAction.header")}
            secondHeader={i18n.t("administration.enableAction.secondHeader")}
            icon={<EnableIcon/>}
            content={content}
            actionText={i18n.t("administration.enableAction.actionText")}
            action={props.confirm}
            cancel={props.closePopup}
            testId="enable-popup"
            httpError={
                <>
                    {!Api.isSuccess(props.response) && (
                        <HttpError
                            response={props.response}
                            cause={i18n.t("administration.errors.enableErrorSuffix")}
                            translatedFields={{
                                id: i18n.t("administration.errors.idNotFound")
                            }}
                        />
                    )}
                </>
            }
            isWaiting={props.isWaiting}
        />
    );
}
